<div class="card">
  <div class="row">
    <div class="col-12">
      <div class="coverage-level text-center mt-3 mb-3">{{ cardData.name }}</div>
      <div class="text-center">
        <span class="dollar-sign">$</span>
        <span class="level-price mb-3">{{ displayPrice }}</span>
        <br />
        <span class="duration mt-2 mb-1">
          Annual Plan
          <br />* Price includes a one-time, nonrefundable administration fee
        </span>
      </div>
    </div>
  </div>

  <div class="row mt-3 mb-2">
    <div class="col-3 p-0"></div>
    <div class="col-6 p-0">
      <div class="join-now" (click)="onJoinNow()" id="selectPlanButton">join now</div>
    </div>
    <div class="col-3 p-0"></div>
    <div class="col-12 mt-4 mb-4 text-center">
      <a href="" class="benefit-link" (click)="setPlanDetails(cardData)" [routerLink]="['/plan']" [queryParams]="{practiceId: practiceId, templateId: templateId, coverageLevelName: cardData.caption, pageName: pageName}" id="benefitDetailsLink">Click here for Benefit Details</a>
    </div>
    <div class="col-12 mb-4 text-center">
      <label class="tax-text">*Taxes may apply</label>
    </div>
  </div>
</div>
